"use client";

import { type DeviceOrientation, getDeviceOrientation } from "@/lib/utils/mobile-orientation";
import { useEffect, useState } from "react";

export function useDeviceOrientation(): DeviceOrientation | null {
  const [orientation, setOrientation] = useState<DeviceOrientation | null>(null);

  useEffect(() => {
    const updateOrientation = () => {
      setOrientation(getDeviceOrientation());
    };

    updateOrientation();

    const portraitQuery = window.matchMedia("(orientation: portrait)");
    portraitQuery.addEventListener("change", updateOrientation);
    window.addEventListener("orientationchange", updateOrientation);
    window.addEventListener("resize", updateOrientation);

    return () => {
      portraitQuery.removeEventListener("change", updateOrientation);
      window.removeEventListener("orientationchange", updateOrientation);
      window.removeEventListener("resize", updateOrientation);
    };
  }, []);

  return orientation;
}
